import { CombinedGraphQLErrors, ServerError } from '@apollo/client';

export const errorMessage = (error = {}) => {
  if (ServerError.is(error)) {
    return 'Oops, seems we are having some issues, support has been notified';
  }

  if (CombinedGraphQLErrors.is(error)) {
    const [{ message } = {}] = error.errors;
    return message;
  }

  return null;
};

export const errorCode = (error = {}) => {
  if (ServerError.is(error)) {
    return error.name;
  }

  if (CombinedGraphQLErrors.is(error)) {
    const [{ extensions } = {}] = error.errors;
    return extensions?.code;
  }

  return null;
};

export const resultErrorCode = (error = {}) => {
  const { errors = [] } = JSON.parse(error);
  const [{ extensions } = {}] = errors;
  return extensions?.code;
};

export const errorType = {
  BAD_USER_INPUT: 'BAD_USER_INPUT',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
};
